import { Stack, Text } from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLoggedInWithOrgContextState } from "../../common/auth/useLoggedInWithOrgContextState";
import { useApiError } from "../../common/errors/useApiError";
import { TipTap } from "../../common/input/TipTap/TipTap";
import { generateHTMLFromTextDocument } from "../../common/input/TipTap/downloadTextDocument";
import { useSub } from "../../common/subscription/useSub";
import { useSaveOrganization } from "../organizations/current/useOrganizationEditor";

export const StandardTerms = () => {
  const authState = useLoggedInWithOrgContextState();
  const { saveOrganization } = useSaveOrganization();
  const { t } = useTranslation();
  const displayer = useApiError();
  const { canUpdateOrganization } = useSub();
  const [initialContent] = useState<string>(authState.selectedOrg.standardTerms ?? "");

  const save = async (value: string) => {
    try {
      await saveOrganization({ standardTerms: { value: generateHTMLFromTextDocument(value) } });
    } catch (e) {
      displayer.trigger(e);
      throw e;
    }
  };

  return (
    <Stack spacing="3">
      <Text fontWeight="medium">{t("Standard terms")}</Text>
      <Text fontSize="sm" color="smMuted">
        {t("These terms must be read and accepted by suppliers before they can submit a bid in any procurement.")}
      </Text>
      {canUpdateOrganization || initialContent ? (
        <TipTap
          ariaLabel={t("Standard terms") ?? ""}
          content={initialContent}
          editable={canUpdateOrganization}
          onUpdate={save}
        />
      ) : (
        <Text fontSize="sm" color="smMuted">
          {t("No standard terms set")}
        </Text>
      )}
    </Stack>
  );
};
